/* Only recalls the existing header. Its native mobile menu retains its own controller. */
(() => {
  'use strict';
  const control=document.querySelector('[data-persistent-menu]');if(!control)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let header,frame=0,openingFrame=0,closeTimer=0,opened=false,closing=false,unavailable=false,openY=0,spacer=null;
  const tone=()=>{
    const page=document.querySelector('[data-oa-page]');
    if(page){const r=page.getBoundingClientRect();if(r.top<70&&r.bottom>70){if(page.classList.contains('is-cinematic'))return page.dataset.menuTone||'navy';return [...page.querySelectorAll('[data-oa-tone="ivory"]')].some(el=>{const b=el.getBoundingClientRect();return b.top<=70&&b.bottom>70})?'ivory':'navy';}}
    return header?.classList.contains('dc-on-ivory')?'ivory':'navy';
  };
  const finishClose=()=>{
    clearTimeout(closeTimer);header?.classList.remove('is-recalled','is-recall-visible');header?.removeAttribute('data-recall-tone');spacer?.remove();spacer=null;closing=false;schedule();
  };
  const close=(restore=false)=>{
    if(!opened)return;
    opened=false;closing=true;cancelAnimationFrame(openingFrame);
    const native=header.querySelector('.d-menu-toggle');if(native?.getAttribute('aria-expanded')==='true')native.click();
    header.classList.remove('is-recall-visible');control.setAttribute('aria-expanded','false');control.setAttribute('aria-label','Mostra intestazione');
    if(restore||header.contains(document.activeElement))control.focus({preventScroll:true});
    closeTimer=setTimeout(finishClose,reduced.matches?0:330);
  };
  const update=()=>{
    frame=0;if(!header?.isConnected)return;
    const currentTone=tone();control.dataset.tone=currentTone;
    if(opened||closing){header.dataset.recallTone=currentTone;return;}
    const rect=header.getBoundingClientRect(),style=getComputedStyle(header);
    const ratio=Math.max(0,Math.min(rect.bottom,innerHeight)-Math.max(0,rect.top))/Math.max(1,rect.height);
    const opaque=Number(style.opacity||1),interactive=style.visibility!=='hidden'&&style.display!=='none'&&style.pointerEvents!=='none';
    if(!interactive||ratio<.80||opaque<.75)unavailable=true;
    else if(ratio>.96&&opaque>.96)unavailable=false;
    if(!unavailable&&document.activeElement===control)header.querySelector('a')?.focus({preventScroll:true});
    control.hidden=!unavailable;
    document.documentElement.classList.toggle('d-header-recall-needed',unavailable);
  };
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  const open=()=>{
    if(!header)return;if(closing)finishClose();
    const style=getComputedStyle(header),height=header.getBoundingClientRect().height;
    if(style.position!=='fixed'&&style.position!=='absolute'){
      spacer=document.createElement('div');spacer.setAttribute('aria-hidden','true');spacer.dataset.headerRecallSpacer='';spacer.style.height=`${height}px`;header.before(spacer);
    }
    control.style.setProperty('--recall-height',`${height}px`);openY=scrollY;opened=true;
    header.dataset.recallTone=tone();header.classList.add('is-recalled');
    document.documentElement.classList.remove('d-header-recall-needed');
    control.hidden=false;control.setAttribute('aria-expanded','true');control.setAttribute('aria-label','Nascondi intestazione');
    // Force the start pose once. All subsequent frames are browser-composited.
    header.getBoundingClientRect();
    openingFrame=requestAnimationFrame(()=>{if(!opened)return;header.classList.add('is-recall-visible');header.querySelector('a')?.focus({preventScroll:true});});
  };
  control.addEventListener('click',()=>opened?close(true):open());
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&opened){e.preventDefault();close(true);}});
  document.addEventListener('click',e=>{if(opened&&header.contains(e.target)&&e.target.closest('a'))close();});
  window.addEventListener('scroll',()=>{if(opened&&Math.abs(scrollY-openY)>Math.max(120,innerHeight*.16))close();schedule();},{passive:true});
  window.addEventListener('resize',()=>{if(opened){const height=header.getBoundingClientRect().height;control.style.setProperty('--recall-height',`${height}px`);if(spacer)spacer.style.height=`${height}px`;}schedule();},{passive:true});window.addEventListener('pageshow',schedule);
  document.addEventListener('dyluma:scene-tone',schedule);document.addEventListener('transitionend',schedule);document.addEventListener('focusin',schedule);
  const observer=new MutationObserver(records=>{if(records.some(r=>r.attributeName!=='data-recall-tone'))schedule();});
  const bind=()=>{observer.disconnect();header=document.querySelector('.d-header');if(header)observer.observe(header,{attributes:true,attributeFilter:['class','style','hidden']});schedule();};
  document.addEventListener('shopify:section:unload',e=>{if(header&&e.target.contains(header)){close();finishClose();}});
  document.addEventListener('shopify:section:load',bind);bind();
})();
